import 'angular';

import './z-index-fix.css';

import addDirective from './add/';
import updateDirective from './update/';
import deleteDirective from './delete/';

const MODULE_NAME = 'daupler.incidents.components.buttons.locations';

var app = angular.module(MODULE_NAME, [
	'brg',
]);
app.directive('addLocation', addDirective);
app.directive('updateLocation', updateDirective);
app.directive('deleteLocation', deleteDirective);

export default MODULE_NAME;
